import { render } from "./BlogPages.vue?vue&type=template&id=5f3eb012&scoped=true"
import script from "./BlogPages.vue?vue&type=script&lang=js"
export * from "./BlogPages.vue?vue&type=script&lang=js"

import "./BlogPages.vue?vue&type=style&index=0&id=5f3eb012&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f3eb012"]])

export default __exports__